import React, { useState } from 'react';
import { CheckIcon } from '../lib/icons';
import { useReveal } from '../lib/useReveal';
const CHECKOUT_BASE = 'https://pagos.academiaholisticaargentina.com/cart/48444837920985:1';
const CHECKOUT_PRO = 'https://pagos.academiaholisticaargentina.com/cart/48444840083673:1';
function FeatureItem({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="flex items-start gap-2 text-left" data-id="element-255">
      <div className="bg-[#eab308]/20 p-0.5 rounded-full flex-shrink-0 mt-0.5" data-id="element-256">
        <CheckIcon className="w-3 h-3 text-[#eab308]" strokeWidth={3} data-id="element-257" />
      </div>
      <span className="text-gray-300 text-xs sm:text-sm leading-snug" data-id="element-258">
        {children}
      </span>
    </div>;
}
export function PricingSection() {
  const [ref1, vis1] = useReveal();
  const [ref2, vis2] = useReveal();
  const [selected, setSelected] = useState<'pro' | 'base'>('pro');
  const checkoutUrl = selected === 'pro' ? CHECKOUT_PRO : CHECKOUT_BASE;
  const ctaLabel = selected === 'pro' ? '💎 QUIERO EL KIT PRO' : '📦 QUIERO LA MAESTRÍA';
  return <section className="bg-black py-12 md:py-16 px-5 sm:px-6 relative overflow-hidden border-t border-white/5" data-id="element-259">
      <div className="container mx-auto max-w-5xl" data-id="element-260">
        <div ref={ref1} className={`reveal text-center mb-8 ${vis1 ? 'is-visible' : ''}`} data-id="element-261">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4 leading-tight" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-262">
            Elegí tu camino de formación
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-263">
            Dos opciones diseñadas para acompañarte desde tu primera práctica
            hasta tu desarrollo profesional.
          </p>
        </div>

        <div ref={ref2} id="pricing-offer" style={{
        scrollMarginTop: '80px'
      }} className={`reveal ${vis2 ? 'is-visible' : ''}`} data-id="element-264">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 items-stretch" data-id="element-265">
            {/* Pro Card */}
            <div onClick={() => setSelected('pro')} className={`relative bg-gradient-to-b from-[#111111] to-[#0a0a0a] rounded-xl p-5 sm:p-6 flex flex-col z-10 cursor-pointer transition-all duration-300 ${selected === 'pro' ? 'border-2 border-[#eab308] shadow-[0_0_50px_rgba(234,179,8,0.2)]' : 'border-2 border-white/10 opacity-70 hover:opacity-90'}`} data-id="element-266">
              {/* Selection indicator */}
              <div className={`absolute top-4 right-4 w-6 h-6 rounded-full border-2 flex items-center justify-center transition-all ${selected === 'pro' ? 'border-[#eab308] bg-[#eab308]' : 'border-white/30 bg-transparent'}`} data-id="element-267">
                {selected === 'pro' && <CheckIcon className="w-3.5 h-3.5 text-[#0f0f1a]" strokeWidth={3} data-id="element-268" />}
              </div>

              <div className="inline-flex self-center bg-gradient-to-r from-[#eab308] to-[#d4a017] text-[#0f0f1a] text-[10px] sm:text-xs font-bold px-4 py-1.5 rounded-full shadow-lg mb-1 whitespace-nowrap" data-id="element-269">
                ⭐ RECOMENDADO
              </div>
              <div className="inline-flex self-center bg-white/10 text-white text-[10px] sm:text-xs font-bold px-3 py-1 rounded-full mb-4 whitespace-nowrap" data-id="element-270">
                👑 MÁS COMPLETO
              </div>

              <div className="relative text-center mb-5" data-id="element-271">
                <span className="text-[#eab308] text-[10px] sm:text-xs font-bold tracking-[0.15em] uppercase mb-2 block" data-id="element-272">
                  KIT PRO
                </span>
                <h3 className="text-xl sm:text-2xl font-bold text-white mb-3" style={{
                fontFamily: "'Playfair Display', serif"
              }} data-id="element-273">
                  Kit Reiki Pro
                </h3>
                <p className="text-4xl sm:text-5xl font-extrabold text-[#eab308] leading-none" style={{
                textShadow: '0 0 30px rgba(234,179,8,0.4)'
              }} data-id="element-274">
                  $29.990
                </p>
                <p className="text-gray-500 text-xs line-through mt-1.5" data-id="element-275">
                  $84.930
                </p>
                <p className="text-[#eab308] font-bold text-[10px] sm:text-xs mt-1.5" data-id="element-276">
                  💳 Hasta 3 cuotas sin interés
                </p>
              </div>

              <div className="space-y-2 mb-5 flex-grow" data-id="element-277">
                <p className="text-gray-400 text-[10px] sm:text-xs font-bold uppercase tracking-wider mb-2" data-id="element-278">
                  Todo lo del Sistema Base +
                </p>
                <div className="bg-[#eab308]/10 border border-[#eab308]/20 rounded-lg p-3 space-y-2 mb-3" data-id="element-279">
                  <p className="text-[#eab308] font-bold text-xs mb-1.5" data-id="element-280">
                    💎 Herramientas Profesionales
                  </p>
                  <FeatureItem data-id="element-281">
                    Certificado Oficial de Practitioner Profesional
                  </FeatureItem>
                  <FeatureItem data-id="element-282">
                    Pack de Documentación Profesional completo
                  </FeatureItem>
                  <FeatureItem data-id="element-283">
                    30 Plantillas de Redes Sociales editables en Canva
                  </FeatureItem>
                  <FeatureItem data-id="element-284">Guión de Primera Sesión</FeatureItem>
                  <FeatureItem data-id="element-285">Protocolo de Programa de 4 Sesiones</FeatureItem>
                  <FeatureItem data-id="element-286">
                    Masterclass — Cómo fijar tus precios sin subestimarte
                  </FeatureItem>
                </div>
              </div>

              <p className="text-center text-gray-400 text-[10px] sm:text-xs" data-id="element-287">
                Solo $10.000 más que el sistema base.
              </p>
            </div>

            {/* Base Card */}
            <div onClick={() => setSelected('base')} className={`relative bg-[#111111] rounded-xl p-5 sm:p-6 flex flex-col cursor-pointer transition-all duration-300 ${selected === 'base' ? 'border-2 border-[#eab308] shadow-[0_0_50px_rgba(234,179,8,0.2)]' : 'border-2 border-white/10 opacity-70 hover:opacity-90'}`} data-id="element-288">
              {/* Selection indicator */}
              <div className={`absolute top-4 right-4 w-6 h-6 rounded-full border-2 flex items-center justify-center transition-all ${selected === 'base' ? 'border-[#eab308] bg-[#eab308]' : 'border-white/30 bg-transparent'}`} data-id="element-289">
                {selected === 'base' && <CheckIcon className="w-3.5 h-3.5 text-[#0f0f1a]" strokeWidth={3} data-id="element-290" />}
              </div>

              <div className="text-center mb-5" data-id="element-291">
                <span className="text-gray-400 text-[10px] sm:text-xs font-bold tracking-[0.15em] uppercase mb-2 block" data-id="element-292">
                  📦 MAESTRÍA
                </span>
                <h3 className="text-xl sm:text-2xl font-bold text-white mb-3" style={{
                fontFamily: "'Playfair Display', serif"
              }} data-id="element-293">
                  Sistema Maestría Reiki
                </h3>
                <p className="text-4xl sm:text-5xl font-extrabold text-white leading-none" style={{
                textShadow: '0 0 30px rgba(255,255,255,0.15)'
              }} data-id="element-294">
                  $19.990
                </p>
                <p className="text-gray-500 text-xs line-through mt-1.5" data-id="element-295">
                  $47.940
                </p>
                <p className="text-gray-300 font-bold text-[10px] sm:text-xs mt-1.5" data-id="element-296">
                  💳 Hasta 3 cuotas sin interés
                </p>
              </div>

              <div className="space-y-2 mb-5 flex-grow" data-id="element-297">
                <p className="text-gray-400 text-[10px] sm:text-xs font-bold uppercase tracking-wider mb-2" data-id="element-298">
                  Todo lo que recibís hoy:
                </p>
                <FeatureItem data-id="element-299">TOMO I — El Despertar del Canal</FeatureItem>
                <FeatureItem data-id="element-300">TOMO II — Simbología y Distancia</FeatureItem>
                <FeatureItem data-id="element-301">TOMO III — La Maestría Espiritual</FeatureItem>
                <FeatureItem data-id="element-302">TOMO IV — El Manual del Iniciador</FeatureItem>
                <FeatureItem data-id="element-303">
                  TOMO V — Reiki Business: Salida Laboral
                </FeatureItem>
                <FeatureItem data-id="element-304">TOMO VI — Protocolos de Emergencia</FeatureItem>
                <div className="pt-2" data-id="element-305">
                  <p className="text-[#eab308] font-bold text-sm mb-2" data-id="element-306">
                    🎁 + 6 Bonos exclusivos
                  </p>
                  <FeatureItem data-id="element-307">Reiki en 7 Días</FeatureItem>
                  <FeatureItem data-id="element-308">Mapa de Chakras Aplicado</FeatureItem>
                  <FeatureItem data-id="element-309">Manual Anti-Dudas</FeatureItem>
                  <FeatureItem data-id="element-310">Reiki para Ansiedad y Estrés</FeatureItem>
                  <FeatureItem data-id="element-311">Reiki de Bolsillo</FeatureItem>
                  <FeatureItem data-id="element-312">
                    Diario de Práctica y Progreso 30 Días
                  </FeatureItem>
                </div>
                <div className="pt-2 border-t border-white/10 mt-2" data-id="element-313">
                  <FeatureItem data-id="element-314">Acceso inmediato y de por vida</FeatureItem>
                  <FeatureItem data-id="element-315">Garantía de 7 días sin preguntas</FeatureItem>
                </div>
              </div>
            </div>
          </div>

          {/* Single CTA Button */}
          <div className="mt-8 max-w-xl mx-auto" data-id="element-316">
            <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="w-full block py-4 md:py-5 rounded-xl text-[#0f0f1a] font-bold text-sm sm:text-base md:text-lg tracking-wider sm:tracking-widest uppercase text-center transition-all shadow-[0_0_30px_rgba(234,179,8,0.4)] hover:shadow-[0_0_40px_rgba(234,179,8,0.6)] hover:-translate-y-1 bg-[#eab308] hover:bg-[#d4a017] border border-[#eab308]/50" style={{
            fontFamily: "'Inter', sans-serif",
            letterSpacing: '0.05em'
          }} data-id="element-317">
              {ctaLabel}
            </a>
            <p className="text-center text-gray-400 text-xs md:text-sm font-medium mt-3" data-id="element-318">
              💳 Mercado Pago — Tarjeta de crédito — Transferencia
            </p>
            <p className="text-center text-gray-500 text-xs md:text-sm font-medium mt-1" data-id="element-319">
              🔒 Pago seguro — Acceso inmediato — Garantía 7 días
            </p>
          </div>
        </div>
      </div>
    </section>;
}